import { React, useState } from "react";
import { FaTable, FaCalendar } from "react-icons/fa";
import Divider from "@material-ui/core/Divider";
import { Card, Button } from "react-bootstrap";
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";

//importer page
import TableCampagneR from "./TableCampagneR";
import CalendrierCampagneR from "./CalendrierCampagneR";

function PageCampagneR() {
  //condition sur l'evenement de clique
  const [tableauClicked, setTableauClicked] = useState(true);
  const [calendarClicked, setCalendarClicked] = useState(false);

  const handleClickTableau = () => {
    setTableauClicked(true);
    setCalendarClicked(false);
  };

  const handleClickCalendar = () => {
    setTableauClicked(false);
    setCalendarClicked(true);
  };

  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne Reseaux Sociaux</h1>
            </div>
            <div className="col-sm-6">

            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}

      {/* content */}
      <section className="content">
        {/* container-fluid */}
        <div className="container-fluid">
          {/* <Divider /> */}
          {/* Buttons Calendrier et tableau */}
          <div className="row mt-2">
            <div className="col-md-12">
              <div className="card-deck ">
                <Card className="Campagne-card-filter">
                  <Card.Body>
                    <div className="row d-flex justify-content-center">
                      {/* Button vers la page Tableau */}
                      <div className="col">
                        <Button
                          className="my-custom-class-btn-style mr-2"
                          variant="secondary"
                          disabled={tableauClicked}
                          onClick={handleClickTableau}
                        >
                          <FaTable className="icon-campagne mr-3" />
                          Tableau
                        </Button>
                      </div>
                      {/* /.Button vers la page Tableau */}
                      {/* Button vers la page calendrier */}
                      <div className="col">
                        <Button
                          className="my-custom-class-btn-style mr-2"
                          variant="secondary"
                          disabled={calendarClicked}
                          onClick={handleClickCalendar}
                        >
                          <FaCalendar className="icon-campagne mr-3" />
                          Calendrier
                        </Button>
                        {/* /.Button vers la page calendrier */}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
          {/*/.Buttons Calendrier et tableau */}
          {/* card */}
          {tableauClicked && <TableCampagneR />}
          {calendarClicked && <CalendrierCampagneR />}
          {/*/.card */}
        </div>
        {/* /.container-fluid */}
      </section>
      {/* /.content */}
    </div>

  );
}

export default PageCampagneR;
